import loadReturnSelectedOrders from "@NA/Handlers/ADIReturnSelectOrderhandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import Select from "@insite/mobius/Select";
import TextField from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { useEffect, useState } from "react";
import { FC, useContext } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";
import { getProp } from "@insite/mobius/utilities";
import RadioGroup from "@insite/mobius/RadioGroup";
import Radio from "@insite/mobius/Radio";
import TextArea from "@insite/mobius/TextArea";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import ADIAddSerialNumbersModal from "@NA/Components/ADIAddSerialNumbersModal";
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        selectedOrdersList: state.ADIGlobalData.ADISelectedOrdersList.selectedOrdersList,
        selectedOrderResults: state.ADIGlobalData.ADIRMASelectOrderStore.rmaSelectOrderState,
        orderLines: state,
    };
};

const mapDispatchToProps = {
    loadReturnSelectedOrders,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ReturnOrderStyles {
    container?: InjectableCss;
    accordianContainer?: InjectableCss;
    accordianHeader?: InjectableCss;
    title?: TypographyProps;
    dataContainer?: GridContainerProps;
    imageContainer?: GridItemProps;
    infoContainer?: GridItemProps;
    returnSelectContainer?: GridItemProps;
    checkbox?: InjectableCss;
    footerBtnWrapper?: InjectableCss;
    continueBtn?: InjectableCss;
    cancelReturn?: InjectableCss;
    disableBtn?: InjectableCss;
    checkboxWrapper?: InjectableCss;
    descriptionText?: InjectableCss;
    smallText?: InjectableCss;
    dealerLink?: InjectableCss;
    dropdownList?: InjectableCss;
    dropdownValues?: InjectableCss;
    dropdownLabel?: InjectableCss;
    dropdownContainer?: InjectableCss;
    dropdownValue?: InjectableCss;
    icon?: TypographyProps;
    inputWrapper?: InjectableCss;
    inputField?: InjectableCss;
    inputFieldLabel?: InjectableCss;
    radioButtonWrapper?: InjectableCss;
    textareaWrapper?: InjectableCss;
    statusWrapper?: InjectableCss;
    indRadioSelection?: InjectableCss;
    addSerialNumberWrapper?: InjectableCss;
    errorInputField?: InjectableCss;
    errorInputFieldLabel?: InjectableCss;
    addSerialNumber?: InjectableCss;
    errorAddSerialNumber?: InjectableCss;
    input?: InjectableCss;
    errorInput?: InjectableCss;
    continuebutton?: InjectableCss;
}

interface Selection {
    qty: number;
    techRA: string;
    serialNumbers: string[];
    type: string; //"CR"
    option: string; //"2"
    orderNumber: string; //"CF9RCH01"
    partNumber: string; //"AD-TG7FEA"
    description: string; //"No Video: testing"
    defectReason: string; // "No Video"
    returnReason: string;
    isSubmit: boolean;
    error: {
        qty: boolean;
        techRA: boolean;
        serialNumbers: boolean;
        type: boolean;
        option: boolean;
        orderNumber: boolean;
        partNumber: boolean;
        description: boolean;
        defectReason: boolean;
        returnReason: boolean;
        isSubmit: boolean;
    };
}

export const returnOrderStyles: ReturnOrderStyles = {
    continuebutton: {
        css: css`
            background-color: #c71e1e;
            color: #fff;
            font-weight: normal;
            text-align: center;
            border: 0px;
            border-radius: 4px;
            padding: 0px 21px 3px 21px !important;
            height: 28px;
            line-height: 28px;
             min-height: 40px;
            :hover {
                background-color: #c71e1e;
                border-color: 1px solid #666 !important;
            }
            span {
                top: 2px;
                position: relative;
            }
        `,
    },
    accordianHeader: {
        css: css`
            padding: 1rem;
            border: 1px solid #ccc;
            margin-bottom: 20px;
        `,
    },
    title: {
        css: css`
            font-weight: 700;
            font-size: 20px;
        `,
    },
    accordianContainer: {
        css: css`
            margin-bottom: 40px;
        `,
    },
    imageContainer: {
        width: [12, 12, 2, 2, 2],
        css: css`
            img {
                width: 110px;
                margin: 0 auto;
            }
        `,
    },
    infoContainer: {
        width: [12, 12, 4, 4, 4],
        css: css`
            flex-direction: column;
            span {
                display: block;
                font-size: 14px;
            }
            h6 {
                font-weight: 600;
            }
        `,
    },
    returnSelectContainer: {
        width: [12, 12, 6, 6, 6],
        css: css`
            span {
                font-size: 14px;
            }
            display: flex;
            flex-direction: column;
        `,
    },
    footerBtnWrapper: {
        css: css`
            margin-top: 15px !important;
            margin-bottom: 20px !important;
            padding-top: 0px !important;
            display: flex;
            gap: 15px;
            justify-content: right;
        `,
    },
    continueBtn: {
        css: css`
            cursor: pointer;
            pointer-events: default;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${ADIColors.lightRed2} !important;
            color: ${ADIColors.white};
            border-color: ${ADIColors.lightRed2} !important;
            :hover {
                background-color: ${ADIColors.lightRed2} !important;
                border-color: ${ADIColors.lightRed2} !important;
            }
        `,
    },
    disableBtn: {
        css: css`
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${ADIColors.gray3};
            color: ${ADIColors.white};
            border-color: ${ADIColors.gray3};
            pointer-events: none;

            :hover {
                background-color: ${ADIColors.gray3};
                border-color: ${ADIColors.gray3};
            }
        `,
    },
    cancelReturn: {
        css: css`
            border-radius: 4px;
            background-color: ${ADIColors.white};
            border-color: ${getColor("primary")};

            :hover {
                background-color: ${ADIColors.white};
                border-color: ${getColor("primary")};
            }
            span {
                color: ${getColor("primary")};
                font-size: inherit !important;
            }
        `,
    },
    checkbox: {
        css: css`
            text-align: center;
            justify-content: center;
            display: flex;
            span {
                border-color: ${ADIColors.black2} !important;
                box-shadow: none !important;
            }
        `,
    },
    checkboxWrapper: {
        css: css`
            align-items: center;
            justify-content: center;
        `,
    },
    descriptionText: {
        css: css`
            font-size: 12px;
            font-weight: 700;
        `,
    },
    smallText: {
        css: css`
            display: inline-block;
            margin-right: 0.9375em;
            white-space: nowrap;
        `,
    },
    dataContainer: {
        css: css`
            padding: 0.5em 1em;
            min-height: 100px;
            border-bottom: solid 1px #eee;
            font-size: 12px;
        `,
    },
    dealerLink: {
        css: css`
            text-decoration: underline;
            color: #0033ff !important;
            margin-right: 3px;
        `,
    },
    dropdownList: {
        css: css`
            border-radius: 0 0 7px 7px;
            box-shadow: 1px 2px 14px 4px rgba(57, 57, 58, 0.25);
            background: ${ADIColors.white};
            position: absolute;
            width: 250px !important;
            top: 90%;
            z-index: 9;
        `,
    },
    dropdownValues: {
        css: css`
            min-height: 40px;
            border-bottom: 1px solid ${ADIColors.gray3};
            font-weight: 600;
            padding: 13px 12px;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            cursor: pointer;

            &:last-child {
                border-bottom: 0;
                border-radius: 0 0 7px 7px;
            }

            &.active,
            &:hover {
                background-color: ${ADIColors.blue1};
                color: ${ADIColors.white};
            }
        `,
    },
    dropdownContainer: {
        css: css`
            position: relative;
            width: 250px;
            margin-bottom: 15px;
        `,
    },
    inputWrapper: {
        css: css`
            display: flex;
            margin-bottom: 15px;
            gap: 15px;
        `,
    },
    inputField: {
        css: css`
            width: 90px !important;
            text-align: center;
            padding: 5px !important;
        `,
    },
    errorInputField: {
        css: css`
            color: ${ADIColors.red1};
            width: 90px !important;
            text-align: center;
            padding: 5px !important;
        `,
    },
    inputFieldLabel: {
        css: css`
            font-weight: bold;
            display: block;
            margin-bottom: 5px;
        `,
    },
    errorInputFieldLabel: {
        css: css`
            font-weight: bold;
            display: block;
            margin-bottom: 5px;
            color: ${ADIColors.red1};
        `,
    },
    dropdownLabel: {
        css: css`
            font-weight: bold;
            margin-top: 15px;
        `,
    },
    dropdownValue: {
        css: css`
            width: 250px;
            border: 1px solid;
            border-radius: 6px;
            padding: 9px 9px 9px 15px;
            height: 40px;
            /* background: ${ADIColors.white}; */
            border: 1px solid ${ADIColors.gray3};
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            cursor: pointer;
            position: relative;
            z-index: 10;
            display: flex;
            align-items: normal;
            justify-content: space-between;
        `,
    },
    radioButtonWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-bottom: 15px;
            div {
                display: flex;
            }
        `,
    },
    textareaWrapper: {
        css: css`
            width: 100%;
            margin-bottom: 15px;
        `,
    },
    statusWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            gap: 30px;
            margin-bottom: 15px;
        `,
    },
    indRadioSelection: {
        css: css`
            margin-bottom: 8px;
            div {
                align-items: flex-start;
                margin-top: 3px;
            }
        `,
    },
    addSerialNumberWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    addSerialNumber: {
        css: css`
            padding-top: 15px;
            outline-color: transparent !important;
        `,
    },
    errorAddSerialNumber: {
        css: css`
            padding-top: 15px;
            outline-color: transparent !important;
            > span {
                color: ${ADIColors.red1} !important;
            }
        `,
    },
    input: {
        css: css`
        
        `,
    },
    errorInput: {
        css: css`
            color: ${ADIColors.red1} !important;
            border-color: ${ADIColors.red1} !important;
        `,
    },
};

const styles = returnOrderStyles;

const DetailsForm: FC<any> = React.memo(({ eachProduct, onChange, runValidation }) => {
    const {
        custOptions,
        type,
        techRARequired,
        serialNumberRequired,
        qty,
        orderNumber,
        item,
        returnMinReq,

    } = eachProduct;

    const [selectedReturnReason, setSelectedReaturnReason] = useState(eachProduct?.selection?.type || "");
    const [custOptionsList, setCustOptionsList] = useState(custOptions);
    const [selectedRespond, setSelectedRespond] = useState("");
    const [serialNumberRequiredValue, setserialNumberRequired] = useState([]);
    const [showTechRARequired, setShowTechRARequired] = useState(false);
    const [showSerialNumberRequired, setShowSerialNumberRequired] = useState(false);
    const [serialNumbersFields, setSerialNumbersFields] = useState<any>([]);
    const [isAddSerialNumbersModalOpen, setIsAddSerialNumbersModalOpen] = useState(false);
    const [showDefectiveReason, setShowDefectiveReason] = useState(false);
    const [showReturnReason, setShowReturnReason] = useState(false);
    const [showReasonForReaturn, setShowReasonForReaturn] = useState(eachProduct?.selection?.returnReason!==""?true:false);

    //selection fields
    const [qtyData, setQtyData] = useState(eachProduct?.selection?.qty || 1);
    const [techRaData, setTechRaData] = useState(eachProduct?.selection?.techRA || "");
    const [serialNumbersData, setSerialNumbersData] = useState<any>(eachProduct?.selection?.serialNumbers || []);
    const [typeData, setTypeData] = useState(eachProduct?.selection?.type || "");
    const [optionData, setOptionData] = useState("");
    const [orderNumberData, setOrderNumberData] = useState(orderNumber || "");
    const [partNumberData, setPartNumberData] = useState(item || "");
    const [descriptionData, setDescriptionData] = useState(eachProduct?.selection?.description || "");
    const [defectReasonData, setDefectReasonData] = useState("");
    const [returnReasonData, setReturnReasonData] = useState(eachProduct?.selection?.returnReason || "");
    const [reasonCode, setReasonCode] = useState<any>([]);
    const [error, setError] = useState("");
    const [whyReturning, setWhyReturn] = useState<string>("");
    const [orderQuantity, setMinimumOrderQuantity] = useState<boolean>(false)


    useEffect(() => {
        if (eachProduct.selection) {
            const { type, option, defectReason, description, techRA } = eachProduct.selection;
            switch (type) {
                case "CR":
                    setSelectedReaturnReason(type);
                    setOptionData(option);
                    setShowReturnReason(true);
                    setShowDefectiveReason(true);
                    setDefectReasonData(defectReason);
                    setWhyReturn(type);
                    setDescriptionData(description);
                    break;

                case "RR":
                case "RX":
                    setSelectedReaturnReason(type);
                    setOptionData(option);
                    setShowReturnReason(true);
                    setWhyReturn(type);
                    setDescriptionData(description);
                    break;

                default:
                    setWhyReturn(type);
                    // Optionally handle other cases
                    break;
            }
        }



    }, [])

    useEffect(() => {
        const reasonCodes = sessionStorage.getItem("reasonCodes");
        if (reasonCodes) {
            setReasonCode(JSON.parse(reasonCodes));
        }
    }, []);
    const updateOnchange = () => {

        const hasDescriptionError = !descriptionData || descriptionData.trim() === '' || descriptionData === ':';
        onChange({
            qty: qtyData,
            techRA: techRaData,
            serialNumbers: serialNumbersData,
            type: typeData,
            option: optionData,
            orderNumber: orderNumberData,
            partNumber: partNumberData,
            description: descriptionData,
            defectReason: defectReasonData,
            returnReason: returnReasonData,
            customer_disp: "scrap",
            isSubmit: true,
            error: {
                qty: true,
                techRA: true,
                serialNumbers: true,
                type: true,
                option: showReturnReason,
                orderNumber: true,
                partNumber: true,
                description: hasDescriptionError,
                defectReason: showDefectiveReason,
                returnReason: showReasonForReaturn,
                isSubmit: true,
            },

        });
    };

    useEffect(() => {
        if (serialNumbersData.length > 0) {
            setSerialNumbersFields(serialNumbersData);
        }
    }, [serialNumbersData]);

    useEffect(() => {
        updateOnchange();
    }, [
        qtyData,
        techRaData,
        serialNumbersData,
        typeData,
        optionData,
        defectReasonData,
        descriptionData,
        returnReasonData,
    ]);

    const isDigit = (input: any) => {
        return /^[0-9]+$/.test(input);
    };
    const handleQtyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Number(e.target.value);
        inputValue < 1 ? setMinimumOrderQuantity(true) : setMinimumOrderQuantity(false)
        if (isDigit(inputValue)) {
            if (inputValue <= qtyMax()) {
                if (inputValue < 1) {
                    setError("Minimum quantity is 1");
                    setQtyData(inputValue);
                } else {
                    setError("");
                    setQtyData(inputValue);
                }
                updateOnchange();
            }
        }
    };

    const handleTechRaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTechRaData(e.target.value);
    };

    const handleSerialNumberChange = (newValue: any) => {
        setSerialNumbersData(newValue);
    };

 

    const handleOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {


        setOptionData(e.target.value);

    };

    interface Option {
        label: string;
        value: string;
        data_value: string;

    }


    const handleOption = (option: Option) => {
        if (eachProduct?.error) {
            eachProduct.error.option = false;
        }
        sessionStorage.setItem("option_data_value", option.data_value);
        setOptionData(option.label);
    }

    const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = e.target.value;
        setDescriptionData(newValue);
        runValidation();
        // setTimeout(() => {

        // }, 0);
    };

    const handleDefectReasonChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setDefectReasonData(e.target.value);
    };

    const handleReturnReasonChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setReturnReasonData(e.target.value);
    };


    const returnReason = type.map((item: any) => {
        if (item === "NN") {
            return { label: "Credit - New", type: item };
        }
        if (item === "CR") {
            return { label: "Credit - Defective Item", type: item };
        }
        if (item === "RR") {
            return { label: "Repair", type: item };
        }
        if (item === "RX") {
            return { label: "Exchange - Defective Item", type: item };
        }
    });
    const returningReason = returnReason.map((item: any, index: number) => {


        return (
            <option key={item.type + index} value={item.type}>
                {translate(item.label)}

            </option>
        );

    })



    const reasonForReturn = reasonCode?.map((item: any, index: number) => {
        return (

            <option key={item.code + index} value={item.description}>
                {item.description}
            </option>
        );
    });

    const returnReasonOnchangeHandler = (e: any) => {
        setSelectedReaturnReason("");
        setShowDefectiveReason(false);
        setShowTechRARequired(false);
        setShowSerialNumberRequired(false);
        setShowReturnReason(false);
        setTechRaData("");
        setSerialNumbersData([]);
        setTypeData("");
        setOptionData("");
        setDescriptionData("");
        setDefectReasonData("");
        setReturnReasonData("");
        setShowReasonForReaturn(false);

        if (e.target.value != "") {
            setSelectedReaturnReason(e?.target?.value);
            setWhyReturn(e?.target?.value)
            if (e?.target?.value === "NN") {
                setShowReasonForReaturn(true);
            } else {
                setShowReturnReason(true);
            }

            if (e?.target?.value == "CR" || e?.target?.value == "RX") {
                setShowDefectiveReason(true);
            }

            var trEmpty = (techRARequired.length == 1 && techRARequired[0] == "") || techRARequired.length == 0; // [""]
            const showTechRa = !trEmpty && techRARequired.indexOf(e.target.value) != -1;
            setShowTechRARequired(showTechRa);
            if (isSerialNumberRequired(e?.target?.value)) {
                // let tempArray: string[] = [];
                // for (var x = 1; x <= qty; ++x) {
                //     tempArray.push("");
                // }
                // setSerialNumbersFields(tempArray); // new Array(product.selections.qty).fill('');
                setShowSerialNumberRequired(true);
            }
            setTypeData(e.target.value);
        }
        updateOnchange();
    };

    const qtyMax = (): number => {
        return qty - (eachProduct.returnsCompleted + eachProduct.returnsInProgress);
    };
    

    const showSerialNumberModal = () => {
        setIsAddSerialNumbersModalOpen(true);    
        const serialNumbersFieldsFilter: Array<number | string> = serialNumbersFields.filter((item: any) => item !== null && item !== undefined && item !== "");
        

        const remainingSlots = Math.max(qtyData - serialNumbersFieldsFilter.length, 0);

        const paddedArray = [
            ...serialNumbersFieldsFilter,
            ...Array(remainingSlots).fill(""),
        ].slice(0, qtyData); 

        


        
        setSerialNumbersFields(paddedArray);


    };

    const isSerialNumberRequired = (selectedReason: any) => {
        return !!selectedReason && !!serialNumberRequired && serialNumberRequired.indexOf(selectedReason) != -1;
    };

    const defectiveReason = [
        <option value="" label="Select One">
            {translate("Select One")}
        </option>,
        <option value="No Video" label="No Video">
            {translate("No Video")}
        </option>,
        <option value="No power" label="No power">
            {translate("No power")}
        </option>,
        <option value="Not recording" label="Not recording">
            {translate("Not recording")}

        </option>,
        <option value="Will not communicate" label="Will not communicate">
            {translate("Will not communicate")}
        </option>,
        <option value="Hard Drive issue" label="Hard Drive issue">
            {translate("Hard Drive issue")}
        </option>,
        <option value="Bad Image" label="Bad Image">
            {translate("Bad Image")}
        </option>,
        <option value="No input/ output" label="No input/ output">
            {translate("No input/ output")}
        </option>,
        <option value="Other" label="Other">
            {translate("Other")}
        </option>,
    ];

    const onSerialNumberModalClose = () => {
        const serialNumbersFieldsFilter: Array<number | string> = serialNumbersFields.filter(
            (item: any) => item !== null && item !== undefined && item !== ""
        );
    
        const remainingSlots = Math.max(qtyData - serialNumbersFieldsFilter.length, 0);
    
        const paddedArray = [
            ...serialNumbersFieldsFilter,
            ...Array(remainingSlots).fill(""),
        ].slice(0, qtyData);
    
        setSerialNumbersFields(paddedArray);
        setIsAddSerialNumbersModalOpen(false);
        runValidation();
    };

    return (
        <>
            <StyledWrapper {...styles.inputWrapper}>
                <StyledWrapper>
                    <Typography style={{ color: error ? "#c41230" : "" }}
                        {...(eachProduct?.error?.qty || orderQuantity && qtyData < 1
                            ? { ...styles.errorInputFieldLabel }
                            : { ...styles.inputFieldLabel })}
                    >
                        {translate("Returning*")}
                    </Typography>
                    <TextField
                        value={qtyData}
                        onChange={handleQtyChange}
                        //onBlur={() => setQtyData(qtyData ? qtyData : returnMinReq)}
                        {...(eachProduct?.error?.qty ? { ...styles.errorInputField } : { ...styles.inputField })}
                    />
                    {error && <p style={{ color: "#c41230" }}>{error}</p>}
                </StyledWrapper>
            </StyledWrapper>

            <StyledWrapper {...styles.inputWrapper}>
                <StyledWrapper>
                    <StyledWrapper as="label">
                        <Typography
                            {...(eachProduct?.error?.type
                                ? { ...styles.errorInputFieldLabel }
                                : { ...styles.inputFieldLabel })}
                        >
                            {translate("Why are you returning?*")}
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.dropdownContainer}>
                        <Select
                            {...(eachProduct?.error?.type ? { ...styles.errorInput } : { ...styles.input })}
                            required
                            placeholder="Select"
                            onChange={e => returnReasonOnchangeHandler(e)}
                            onBlur={() => runValidation()}
                            value={whyReturning}

                        >
                            <option value="">{translate("Select One")}</option>
                            {returningReason}
                        </Select>
                    </StyledWrapper>
                </StyledWrapper>

                {whyReturning && techRARequired.every((element:string) => element !== "") && (
                    <StyledWrapper>
                        <StyledWrapper as="label">
                            <Typography
                                {...(eachProduct?.error?.techRA
                                    ? { ...styles.errorInputFieldLabel }
                                    : { ...styles.inputFieldLabel })}
                            >
                                {translate("Vendor Tech RA*")}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.dropdownContainer}>
                            <TextField
                                {...(eachProduct?.error?.techRA ? { ...styles.errorInput } : { ...styles.input })}
                                type="text"
                                placeholder={translate("Enter a Tech RA #")}
                                onChange={handleTechRaChange}
                                maxLength={20}
                                minLength={1}
                                value={techRaData}
                            />
                        </StyledWrapper>
                    </StyledWrapper>
                )}

                {whyReturning && techRARequired.every((element:string) => element !== "") && (
                    <StyledWrapper {...styles.addSerialNumberWrapper}>
                        <Link
                            {...(eachProduct?.error?.serialNumbers
                                ? { ...styles.errorAddSerialNumber }
                                : { ...styles.addSerialNumber })}
                            onClick={() => showSerialNumberModal()}
                        >
                            {translate("Add Serial Numbers*")}
                        </Link>
                    </StyledWrapper>
                )}

                <ADIAddSerialNumbersModal
                    isAddSerialNumbersModalOpen={isAddSerialNumbersModalOpen}
                    serialNumbersFields={serialNumbersFields}
                    onSerialNumberModalClose={onSerialNumberModalClose}
                    handleSerialNumberChange={handleSerialNumberChange}
                    serialNumberData={eachProduct?.selection?.serialNumbers}
                    inputField={qtyData}

                />
            </StyledWrapper>

            {selectedReturnReason && (
                <>
                    {showReturnReason && (
                        <>
                            <StyledWrapper>
                                <Typography
                                    {...(eachProduct?.error?.option
                                        ? { ...styles.errorInputFieldLabel }
                                        : { ...styles.inputFieldLabel })}
                                >
                                    {translate(
                                        "How would you like us to respond if a vendor denies the warranty request(s)?*",
                                    )}
                                </Typography>
                            </StyledWrapper>
                            <StyledWrapper>
                                <RadioGroup
                                    name={item}
                                    // {...styles.radioListGroup}
                                    value={optionData}

                                    onChangeHandler={handleOptionChange}
                                >
                                    <StyledWrapper {...styles.radioButtonWrapper}>
                                        {custOptionsList &&
                                            custOptionsList.map((item: any) => {
                                                if (item.type === selectedReturnReason) {
                                                    return item.options.map((itemList: any, index: number) => {


                                                        return (
                                                            <StyledWrapper {...styles.indRadioSelection}>
                                                                <Radio value={itemList.label} onChange={() => handleOption(itemList)} onBlur={() => runValidation()}></Radio>
                                                                <Typography
                                                                    {...(eachProduct?.error?.option
                                                                        ? { ...styles.errorInput }
                                                                        : { ...styles.input })}
                                                                >
                                                                    {translate(itemList.label)}
                                                                </Typography>
                                                            </StyledWrapper>
                                                        );
                                                    });
                                                }
                                            })}
                                    </StyledWrapper>
                                </RadioGroup>
                            </StyledWrapper>
                        </>
                    )}

                    {showDefectiveReason && (
                        <>
                            <StyledWrapper as="label">
                                <Typography
                                    {...(eachProduct?.error?.defectReason && eachProduct?.error?.isSubmit
                                        ? { ...styles.errorInputFieldLabel }
                                        : { ...styles.inputFieldLabel })}
                                >
                                    {translate("Defective Reason*")}
                                </Typography>
                            </StyledWrapper>
                            <StyledWrapper {...styles.dropdownContainer}>

                                <Select
                                    {...(eachProduct?.error?.defectReason && eachProduct?.error?.isSubmit
                                        ? { ...styles.errorInput }
                                        : { ...styles.input })}
                                    required
                                    placeholder="Select"
                                    // onChange={logValue}
                                    onChange={handleDefectReasonChange}
                                    value={defectReasonData}
                                >
                                    {defectiveReason}
                                </Select>
                            </StyledWrapper>
                        </>
                    )}
                    {showReasonForReaturn && (
                        <>
                            <StyledWrapper as="label">
                                <Typography
                                    {...(eachProduct?.error?.returnReason && eachProduct?.error?.isSubmit
                                        ? { ...styles.errorInputFieldLabel }
                                        : { ...styles.inputFieldLabel })}
                                >
                                    {translate("Reason for return*")}
                                </Typography>
                            </StyledWrapper>
                            <StyledWrapper {...styles.dropdownContainer}>
                                <Select
                                    {...(eachProduct?.error?.returnReason && eachProduct?.error?.isSubmit
                                        ? { ...styles.errorInput }
                                        : { ...styles.input })}
                                    required
                                    placeholder="Select"
                                    //  onChange={logValue}
                                    onChange={handleReturnReasonChange}
                                    onBlur={() => runValidation()}
                                    value={returnReasonData}
                                >
                                    <option value="">{translate("Select One")}</option>
                                    {reasonForReturn}
                                </Select>
                            </StyledWrapper>
                        </>
                    )}

                    <StyledWrapper>
                        <Typography
                            {...(eachProduct?.error?.description
                                ? { ...styles.errorInputFieldLabel }
                                : { ...styles.inputFieldLabel })}
                        >
                            {translate("Description*")}
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.textareaWrapper}>
                        <TextArea

                            {...(eachProduct?.error?.description
                                ? { ...styles.errorInput }
                                : { ...styles.input })}
                            placeholder="200 Character Limit"
                            maxLength={200}
                            onBlur={() => runValidation()}
                            onChange={e => {
                                handleDescriptionChange(e);
                            }}
                            value={descriptionData}
                        >
                            {descriptionData}
                        </TextArea>
                    </StyledWrapper>
                </>
            )}
        </>
    );
});

export const ADIReturnSelectOrder: FC<Props> = ({
    loadReturnSelectedOrders,
    selectedOrdersList,
    selectedOrderResults,
    orderLines,
}) => {
    const [selectedProducts, setSelectedProducts] = React.useState<any[]>([]);
    const { value: order } = useContext(OrderStateContext);
    const [selection, setSelection] = useState<Selection[]>([]);
    const [isContinue, setIsContinue] = useState(false);
    const [clickedSubmit, setclickedSubmit] = useState(false);
    const [resionSelectedForReturn, setresionSelectedForReturn] = useState<string | any>("")
    const handleSelectionChange = (index: number, newSelection: Selection) => {
        setSelection(prevSelection => {
            const updatedSelection = [...prevSelection];
            updatedSelection[index] = newSelection;
            return updatedSelection;
        });
    };

    useEffect(() => {
        const productData = sessionStorage.getItem("productsToBeReturned");
        if (productData) {
            setSelectedProducts(JSON.parse(productData));
        }
    }, []);

    useEffect(() => {
        if (isContinue) {
            setIsContinue(false);
            const hasError = selectedProducts.some(item => Object.values(item.error).some(val => val === true));

            if (!hasError) {
                sessionStorage.setItem("productsToBeReturned", JSON.stringify(selectedProducts));
                history.push("/MyAccount/returns/ConfirmReturns");
            }
        }
    }, [selectedProducts]);


    const history = useHistory();

    const cancelReturnHandler = () => {
        sessionStorage.removeItem("productsToBeReturned");
        sessionStorage.removeItem("ordersSelectedForReturn");
        //history.push("/MyAccount/Order");
        history.push("/MyAccount/Returns/SelectOrders");
    };

    const validateInputs = () => {



        const newUpdatedSelection = selection.map((item, index) => {
            let tempSelection = selectedProducts[index];
            const typeError = !item.type || item.type === "";
            const optionError = item.error.option && (!item.option || item.option === "");
            const isEmpty = !item.description || item.description === "" || item.description === ":";



            let actualDescription = item.description;


            const isInvalidDescription =
                actualDescription === "true" || actualDescription === String(true) ||
                !actualDescription || actualDescription === "" || actualDescription === ":";


            return {
                ...tempSelection,
                error: {
                    qty: item.error.qty ? (item.qty != 0 ? false : true) : false,
                    techRA: item.error.techRA ? (item.techRA == "" ? true : false) : false,
                    serialNumbers: item.error.serialNumbers
                        ? item.serialNumbers.some(element => element == "") || item.serialNumbers.length == 0
                            ? true
                            : false
                        : false,
                    type: typeError,
                    option: optionError,
                    orderNumber: item.error.orderNumber ? (item.orderNumber == "" ? true : false) : false,
                    partNumber: item.error.partNumber ? (item.partNumber == "" ? true : false) : false,
                    description: isInvalidDescription,
                    defectReason: item.error.defectReason ? (item.defectReason == "" ? true : false) : false,
                    returnReason: item.error.returnReason ? (item.returnReason == "" ? true : false) : false,

                    isSubmit: true
                    //isSubmit: item.error.isSubmit ? item.error.isSubmit : !!clickedSubmit,
                },
                selection: item,
            };
        });
        setSelectedProducts(newUpdatedSelection);



        const hasErrors = newUpdatedSelection.some(item => {
            const errors = Object.entries(item.error)
                .filter(([key]) => key !== 'isSubmit')
                .filter(([key, val]) => val === true);


            return errors.length > 0;
        });

        return !hasErrors;

    };
    const isValidSelection = (selection: any[]) => {
        return selection.every((item: any) => {

            if (item.type.trim() === '') {
                return false;
            }


            if (item.error.returnReason && item.returnReason.trim() === '') {
                return false;
            }

            if (item.description.trim() === '' || item.description === ':') {
                return false;
            }


            if (item.error.option && item.option.trim() === '') {
                return false;
            }

            return true;
        });
    };


    const continueHandler = () => {
        sessionStorage.setItem("setreturnToBranch", "true")
        sessionStorage.setItem("setshipToForm", "false")
        let hasInvalidDescription = false;

        selection.forEach((item, index) => {


            // Check for invalid description values
            if (item.description === "true" || item.description === String(true) ||
                !item.description || item.description === "" || item.description === ":") {

                hasInvalidDescription = true;
            }
        });


        validateInputs();


        if (!hasInvalidDescription) {

            sessionStorage.setItem("productsToBeReturned", JSON.stringify(selectedProducts));
            history.push("/MyAccount/returns/ConfirmReturns");
        }
    };
    useEffect(() => {
        if (isContinue) {
            setIsContinue(false);
            const hasError = selectedProducts.some(item => Object.values(item.error).some(val => val === true));
            if (!hasError) {

            } else {

                setclickedSubmit(false);
            }
        }
    }, [selectedProducts]);



    return (
        <>
            <StyledWrapper {...styles.container}>
                <StyledWrapper {...styles.accordianContainer}>
                    <StyledWrapper {...styles.accordianHeader}>
                        <StyledWrapper>
                            <Typography {...styles.title} as={"h3"}>
                                {translate("Select Reason For Return")}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                    <>
                        {selectedProducts &&
                            selectedProducts.map((eachProduct: any, index: number) => {
                                if (eachProduct?.productDto) {
                                    const {
                                        productDto: {
                                            smallImagePath = "",
                                            altText = "",
                                            shortDescription,
                                            properties,
                                            erpNumber,
                                            modelNumber,
                                            manufacturerItem,
                                            customerName,
                                        },
                                        canBeReturned,
                                    } = eachProduct;
                                    if (canBeReturned) {
                                        return (
                                            <GridContainer key={index} {...styles.dataContainer}>
                                                <GridItem {...styles.imageContainer}>
                                                    <Img src={smallImagePath} alt={altText} />
                                                </GridItem>
                                                <GridItem {...styles.infoContainer}>
                                                    <Typography {...styles.descriptionText} as={"h6"}>
                                                        {shortDescription}
                                                    </Typography>
                                                    {properties.branD_PATH && (
                                                        <Typography {...styles.smallText}>
                                                            {properties.branD_SHORTDESC}
                                                        </Typography>
                                                    )}
                                                    {erpNumber && <Typography>{erpNumber}</Typography>}
                                                    {(modelNumber || manufacturerItem) && (
                                                        <Typography>{modelNumber || manufacturerItem}</Typography>
                                                    )}
                                                    {customerName && (
                                                        <Typography>
                                                            {translate("My Part #")}
                                                            {customerName}
                                                        </Typography>
                                                    )}
                                                </GridItem>
                                                <GridItem {...styles.returnSelectContainer}>
                                                    <StyledWrapper {...styles.statusWrapper}>
                                                        <span>
                                                            {" "}
                                                            {translate("Ordered")}: {eachProduct.qty}{" "}
                                                        </span>
                                                        <span>
                                                            {translate("Order #")}: {eachProduct.orderNumber}
                                                        </span>
                                                        {eachProduct.returnsCompleted > 0 && (
                                                            <span>
                                                                {translate(" Already Returned: ")}
                                                                {eachProduct.returnsCompleted}
                                                            </span>
                                                        )}
                                                        {eachProduct.returnsInProgress > 0 && (
                                                            <span>
                                                                {translate(" In Progress: ")}
                                                                {eachProduct.returnsInProgress}
                                                            </span>
                                                        )}
                                                    </StyledWrapper>

                                                    <DetailsForm
                                                        key={index + eachProduct.orderNumber}
                                                        eachProduct={eachProduct}
                                                        runValidation={validateInputs}
                                                        onChange={(newSelection: Selection) => {
                                                            handleSelectionChange(index, newSelection);
                                                        }}
                                                    />
                                                </GridItem>
                                            </GridContainer>
                                        );
                                    }
                                }
                            })}
                    </>
                </StyledWrapper>
            </StyledWrapper>
            <GridItem width={12} {...styles.footerBtnWrapper}>
                <Button
                    {...styles.cancelReturn}
                    onClick={() => {
                        cancelReturnHandler();
                    }}
                    data-test-selector="orders_clearFiltersButton"
                >
                    {translate("Cancel Return")}
                </Button>
                <Button
                    onClick={() => {

                        continueHandler();
                    }}
                    {...styles.continuebutton}
                >
                    {translate("Continue")} <Icon color={ADIColors.white} src={ChevronRight} size={15} />
                </Button>
            </GridItem>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIReturnSelectOrder),
    definition: {
        group: "Return Request (RMA)",
        icon: "Image",
        displayName: "Return Product Select Reason",
        fieldDefinitions: [],
    },
};

export default widgetModule;

